export default __webpack_public_path__ + "static/media/spinner.ba84dcdd.gif";